// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7fd41524","235":"de900d9c","240":"03da4839","274":"4f26a033","751":"5721eb72","892":"b251c266","937":"7447dc83","940":"7157600e","971":"53b3157c"}[chunkId] + ".chunk.js";
};